import { bookLoaded } from "../../books/action";

const allBookFilter = (status) => {
  return async (dispatch) => {
    const response = await fetch("http://localhost:9000/books");
    const books = await response.json();

    dispatch(bookLoaded(books, status));
  };
};

export default allBookFilter;
